import type { OnlinePaymentMethods } from '@tebuto/widget/booking/types'
import type { BuildPaymentOptionsParams, WidgetPaymentMethodId, WidgetPaymentOption } from './payment-option.types'

export const PAYMENT_METHOD_DISPLAY_ORDER: WidgetPaymentMethodId[] = [
    'paypal',
    'google_pay',
    'apple_pay',
    'card',
    'klarna',
    'sepa',
    'bank_transfer',
    'cash',
    'invoice'
]

export function filterOnlinePaymentMethods(
    onlinePaymentMethods: OnlinePaymentMethods,
    isStripeProvider: boolean
): OnlinePaymentMethods {
    if (isStripeProvider) {
        return onlinePaymentMethods.filter((method) => method !== 'paypal') as OnlinePaymentMethods
    }

    return onlinePaymentMethods.filter((method) => method !== 'sepa') as OnlinePaymentMethods
}

function sortPaymentOptions(options: WidgetPaymentOption[]): WidgetPaymentOption[] {
    return [...options].sort(
        (left, right) => PAYMENT_METHOD_DISPLAY_ORDER.indexOf(left.id) - PAYMENT_METHOD_DISPLAY_ORDER.indexOf(right.id)
    )
}

export function buildPaymentOptions({ paymentTypes, methodCopy }: BuildPaymentOptionsParams): WidgetPaymentOption[] {
    const options: WidgetPaymentOption[] = []

    if (paymentTypes.includes('cash')) {
        options.push({
            id: 'cash',
            provider: 'offline',
            method: 'cash',
            actionKind: 'offline-booking',
            label: methodCopy.cash.label,
            description: methodCopy.cash.description
        })
    }

    if (paymentTypes.includes('invoice')) {
        options.push({
            id: 'invoice',
            provider: 'offline',
            method: 'invoice',
            actionKind: 'offline-booking',
            label: methodCopy.invoice.label,
            description: methodCopy.invoice.description
        })
    }

    return sortPaymentOptions(options)
}
